import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/ui/Layout';
import SubHeader from '../components/ui/SubHeader';
import ActionBoxes from '../components/ui/ActionBoxes';

const MainDashboard = () => {
  const navigate = useNavigate();
  const [userRole] = React.useState('admin');
  const [userName] = React.useState('أحمد محمد');

  // Add this block - Handler for quick menu toggle
  const handleQuickMenuToggle = () => {
    // Quick menu toggle handler implementation
  };

  // Add this block - Missing state for ActionBoxes required props
  const [showNewContractModal, setShowNewContractModal] = useState(false);

  // Add this block - Missing contractTypeConfig for ActionBoxes
  const contractTypeConfig = {
    types: [],
    defaultType: null
  };

  // Define all main system sections as action boxes
  const mainMenuActions = [
    {
      id: 'property-dashboard',
      icon: 'Building2',
      label: 'لوحة العقارات',
      color: '#3B82F6',
      bgGradient: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(96, 165, 250, 0.25) 100%)',
      borderColor: 'rgba(59, 130, 246, 0.5)',
      onClick: () => navigate('/property-management-dashboard')
    },
    {
      id: 'clients',
      icon: 'Users',
      label: 'إدارة العملاء',
      color: '#F59E0B',
      bgGradient: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2) 0%, rgba(251, 191, 36, 0.25) 100%)',
      borderColor: 'rgba(245, 158, 11, 0.5)',
      onClick: () => navigate('/client-relationship-management')
    },
    {
      id: 'calendar',
      icon: 'Calendar',
      label: 'التقويم والمواعيد',
      color: '#8B5CF6',
      bgGradient: 'linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(167, 139, 250, 0.25) 100%)',
      borderColor: 'rgba(139, 92, 246, 0.5)',
      onClick: () => navigate('/calendar-and-appointment-scheduling')
    },
    {
      id: 'contracts',
      icon: 'FileText',
      label: 'العقود والموافقات',
      color: '#EF4444',
      bgGradient: 'linear-gradient(135deg, rgba(239, 68, 68, 0.2) 0%, rgba(248, 113, 113, 0.25) 100%)',
      borderColor: 'rgba(239, 68, 68, 0.5)',
      onClick: () => navigate('/contract-approval-workflow')
    },
    {
      id: 'owners',
      icon: 'UserCheck',
      label: 'إدارة الملاك',
      color: '#06B6D4',
      bgGradient: 'linear-gradient(135deg, rgba(6, 182, 212, 0.2) 0%, rgba(34, 211, 238, 0.25) 100%)',
      borderColor: 'rgba(6, 182, 212, 0.5)',
      onClick: () => navigate('/owner-property-management')
    },
    {
      id: 'communication',
      icon: 'MessageSquare',
      label: 'مركز التواصل',
      color: '#EC4899',
      bgGradient: 'linear-gradient(135deg, rgba(236, 72, 153, 0.2) 0%, rgba(244, 114, 182, 0.25) 100%)',
      borderColor: 'rgba(236, 72, 153, 0.5)',
      onClick: () => navigate('/communication-and-follow-up-center')
    },
    {
      id: 'documents',
      icon: 'FileCheck',
      label: 'المستندات والنماذج',
      color: '#14B8A6',
      bgGradient: 'linear-gradient(135deg, rgba(20, 184, 166, 0.2) 0%, rgba(45, 212, 191, 0.25) 100%)',
      borderColor: 'rgba(20, 184, 166, 0.5)',
      onClick: () => navigate('/document-and-form-generation-center')
    },
    {
      id: 'reports',
      icon: 'BarChart3',
      label: 'التقارير والتحليلات',
      color: '#F97316',
      bgGradient: 'linear-gradient(135deg, rgba(249, 115, 22, 0.2) 0%, rgba(251, 146, 60, 0.25) 100%)',
      borderColor: 'rgba(249, 115, 22, 0.5)',
      onClick: () => navigate('/reporting-and-analytics-dashboard')
    },
    {
      id: 'alerts',
      icon: 'Bell',
      label: 'التنبيهات والإشعارات',
      color: '#A855F7',
      bgGradient: 'linear-gradient(135deg, rgba(168, 85, 247, 0.2) 0%, rgba(192, 132, 252, 0.25) 100%)',
      borderColor: 'rgba(168, 85, 247, 0.5)',
      onClick: () => navigate('/staff-alert-and-notification-dashboard')
    },
    {
      id: 'system-admin',
      icon: 'Settings',
      label: 'إدارة النظام',
      color: '#64748B',
      bgGradient: 'linear-gradient(135deg, rgba(100, 116, 139, 0.2) 0%, rgba(148, 163, 184, 0.25) 100%)',
      borderColor: 'rgba(100, 116, 139, 0.5)',
      onClick: () => navigate('/system-administration-and-user-management')
    }
  ];

  // Workflow automation quick access actions
  const workflowAutomationActions = [
    {
      id: 'workflow-automation',
      icon: 'Zap',
      label: 'أتمتة سير العمل',
      color: '#FCA5A5',
      borderColor: 'rgba(250, 165, 165, 0.5)',
      bgGradient: 'linear-gradient(135deg, rgba(250, 165, 165, 0.3) 0%, rgba(255, 105, 97, 0.35) 100%)',
      onClick: () => navigate('/contract-approval-workflow?action=automation')
    },
    {
      id: 'workflow-monitoring',
      icon: 'Activity',
      label: 'مراقبة الأتمتة',
      color: '#8B5CF6',
      bgGradient: 'linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(167, 139, 250, 0.25) 100%)',
      borderColor: 'rgba(139, 92, 246, 0.5)',
      onClick: () => navigate('/contract-approval-workflow?action=monitoring')
    },
    {
      id: 'workflow-jobs',
      icon: 'ListChecks',
      label: 'سجل المهام',
      color: '#FCA5A5',
      borderColor: 'rgba(250, 165, 165, 0.5)',
      bgGradient: 'linear-gradient(135deg, rgba(250, 165, 165, 0.3) 0%, rgba(255, 105, 97, 0.35) 100%)',
      onClick: () => navigate('/contract-approval-workflow?action=jobs')
    }
  ];

  return (
    <Layout userRole={userRole} userName={userName} onQuickMenuToggle={handleQuickMenuToggle}>
      {/* Sub Header with correct title */}
      <SubHeader pageTitle="القائمة الرئيسية" />

      {/* Main Content Container */}
      <div className="min-h-screen bg-background p-4 md:p-6 lg:p-8" dir="rtl">
        <div className="max-w-[1600px] mx-auto space-y-6">
          {/* Main Menu Action Boxes */}
          <ActionBoxes 
            actions={mainMenuActions} 
            showNewContractModal={showNewContractModal} 
            setShowNewContractModal={setShowNewContractModal}
            contractTypeConfig={contractTypeConfig}
          />

          {/* Workflow Automation Quick Access Section */}
          <div className="space-y-3">
            <h2 className="text-lg font-semibold text-foreground flex items-center gap-2">
              <span className="text-2xl">⚡</span>
              الوصول السريع لأتمتة سير العمل
            </h2>
            <ActionBoxes 
              actions={workflowAutomationActions} 
              showNewContractModal={false} 
              setShowNewContractModal={() => {}}
              contractTypeConfig={contractTypeConfig}
            />
          </div>

          {/* Quick Stats Grid */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-3">
            <div className="bg-white/5 border border-white/12 rounded-md p-2 md:p-3 shadow-lg">
              <div className="flex items-center justify-between">
                <div className="text-right">
                  <p className="text-[10px] md:text-xs text-white/70 mb-0.5">إجمالي العقارات</p>
                  <p className="text-sm md:text-lg font-bold text-white">1,247</p>
                </div>
                <div className="w-7 h-7 md:w-8 md:h-8 rounded-md bg-white/10 flex items-center justify-center">
                  <span className="text-sm md:text-base">🏢</span>
                </div>
              </div>
            </div>

            <div className="bg-white/5 border border-white/12 rounded-md p-2 md:p-3 shadow-lg">
              <div className="flex items-center justify-between">
                <div className="text-right">
                  <p className="text-[10px] md:text-xs text-white/70 mb-0.5">العملاء النشطون</p>
                  <p className="text-sm md:text-lg font-bold text-white">856</p>
                </div>
                <div className="w-7 h-7 md:w-8 md:h-8 rounded-md bg-white/10 flex items-center justify-center">
                  <span className="text-sm md:text-base">👥</span>
                </div>
              </div>
            </div>

            <div className="bg-white/5 border border-white/12 rounded-md p-2 md:p-3 shadow-lg">
              <div className="flex items-center justify-between">
                <div className="text-right">
                  <p className="text-[10px] md:text-xs text-white/70 mb-0.5">العقود الجارية</p>
                  <p className="text-sm md:text-lg font-bold text-white">342</p>
                </div>
                <div className="w-7 h-7 md:w-8 md:h-8 rounded-md bg-white/10 flex items-center justify-center">
                  <span className="text-sm md:text-base">📄</span>
                </div>
              </div>
            </div>

            <div className="bg-white/5 border border-white/12 rounded-md p-2 md:p-3 shadow-lg">
              <div className="flex items-center justify-between">
                <div className="text-right">
                  <p className="text-[10px] md:text-xs text-white/70 mb-0.5">المواعيد اليوم</p>
                  <p className="text-sm md:text-lg font-bold text-white">12</p>
                </div>
                <div className="w-7 h-7 md:w-8 md:h-8 rounded-md bg-white/10 flex items-center justify-center">
                  <span className="text-sm md:text-base">📅</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Powered By Footer */}
        <div className="mt-8 pb-6 flex items-center justify-center gap-2">
          <span className="text-sm text-white/70">Powered by</span>
          <img 
            src="/assets/images/k-icon-tiny-1768207136633.png" 
            alt="Logo" 
            className="h-6 w-auto object-contain"
          />
        </div>
      </div>
    </Layout>
  );
};

export default MainDashboard;